import { onBeforeUnmount, onMounted, type Ref } from 'vue';

export function useLayoutMeasurement(rootRef: Ref<HTMLElement | null>, measure: () => void): void {
  let resizeObserver: ResizeObserver | undefined;
  let observedWidth: number | undefined;

  onMounted(() => {
    if (!rootRef.value) {
      return;
    }

    resizeObserver = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width === observedWidth) {
        return;
      }

      observedWidth = entry.contentRect.width;
      measure();
    });
    resizeObserver.observe(rootRef.value);

    document.fonts.ready.then(measure);
  });

  onBeforeUnmount(() => {
    resizeObserver?.disconnect();
  });
}
